import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import "./ChatPage.css";
import profileDefault from "../../../assets/profile_default.png";
import { client, xml } from "@xmpp/client";
import { useRef } from "react";
import { fetchChatuserlist } from "../../header/redux/actions";
import { storeConnection } from "../../header/redux/actions";
import { storeChathistory } from "../../header/redux/actions";
import { storeChat } from "../../header/redux/actions";
import pdf from "../../../assets/pdf_attachment.svg";
import doc from "../../../assets/doc_attachment.svg";
import docx from "../../../assets/doc_attachment.svg";
import ppt from "../../../assets/ppt_attachment.svg";
import pptx from "../../../assets/ppt_attachment.svg";
import xls from "../../../assets/excel_attachment.svg";
import xlsx from "../../../assets/excel_attachment.svg";
import { useNavigate, useParams } from "react-router-dom";
import girne_logo from "../../../assets/girne_logo.webp";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { MAGNIFY } from "../../comman/components/CommonimagePath";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  MY_CHAT_LIST,
  PROFILE,
  READ_MSG_NOTIFICATION,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import { setStoreMessage, setStoreMessageReceived } from "../redux/actions";
const ChatPage = React.lazy(() => import("./ChatPage"));

function UserlistPage(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const ref = useRef(Math.random());

  let documentImage = [
    { key: "pdf", value: pdf },
    { key: "doc", value: doc },
    { key: "docx", value: docx },
    { key: "ppt", value: ppt },
    { key: "pptx", value: pptx },
    { key: "xls", value: xls },
    { key: "xlsx", value: xlsx },
  ];
  let imageext = ["png", "jpeg", "jpg", "webp", "jfif", "svg"];
  let doucmentext = ["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx"];
  let videoext = [
    "mp4",
    "mov",
    "webm",
    "wmv",
    "avi",
    "avchd",
    "flv",
    "f4v",
    "swf",
    "mkv",
    "html5",
  ];
  const [searchname, setSearhname] = useState("");
  const [showChat, setShowchat] = useState(false);
  const [historyarray, setHistoryarray] = useState([]);
  const [nochatfound, setNochatfound] = useState(false);
  const [receiver, setReceiver] = useState({
    recerverJid: "",
    receivername: "",
    receiverimage: "",
  });
  const [senderImage, setSenderimage] = useState("");
  const navigate = useNavigate();
  const param = useParams();
  let getjidFromurl = window.location.pathname.split("/").pop();
  let url = window.location.pathname.split("/");
  var userlist = [];
  let xmppObject;

  useEffect(() => {
    (async () => afterback())();
    // eslint-disable-next-line
  }, []);

  const afterback = async () => {
    window.onpopstate = () => {
      let getcurrentjid = window.location.pathname.split("/").pop();
      let getCurrenturl = window.location.pathname.split("/");
      if (getCurrenturl[1] === "chat" || getCurrenturl[1] === "admin-chat") {
        if(userlist?.length > 0){
          let getjidObj = userlist[0]?.filter(
            (item) => item.jid === getcurrentjid
          );
          if (getjidObj.length !== 0) {
            if (xmppObject?.status === "online") {
              showReceiverchat(getjidObj[0], true, xmppObject);
            }
          }
        }
      }
    };
  };

  // eslint-disable-next-line
  useEffect(() => {
    (async () => createConnection())();
    // eslint-disable-next-line
  }, []);

  const createConnection = async () => {
    let jid;
    let jpass;
    if (url[1] === "admin-chat") {
      const responseProfile = await getRequestcall(PROFILE, url[2]);
      if (responseProfile?.status === 200) {
        let getprofile = await responseProfile.json();
        let profile =
          typeof getprofile?.data?.image_url === "undefined"
            ? profileDefault
            : getprofile?.data?.image_url;
        setSenderimage(profile);
        jid = getprofile?.data?.jid;
        jpass = getprofile?.data?.jpass;
      }
    } else {
      jid = props.jid;
      jpass = props.jpass;
    }
    if (props.xmppclient.status !== "online") {
      const xmpp = client({
        service: process.env.REACT_APP_SERVICE_URL,
        domain: process.env.REACT_APP_DOMAIN,
        resource: ref.current,
        username: jid,
        password: jpass,
      });
      xmpp.on("online", async (jid) => {
        await xmpp.send(xml("presence"));
        xmppObject = xmpp;
        props.storeConnection(xmpp);
        await callUserlist(xmpp);
      });
      //To receive the messages
      xmpp.on("stanza", async (stanza) => {
        if (stanza.is("iq")) {
          let value = stanza
            ?.getChild("fin")
            ?.getChild("set")
            ?.getChild("count");
          if (Number(value?.children[0])) { // After chat history 
             let getList = [];
             getList = historyarray.filter((item) => item);
             console.log("chatList" , getList, stanza)
            if(param?.id){
              dispatch(setStoreMessageReceived({messages:getList, users_id:param?.id}))
            }
            historyarray.length = 0;
            setHistoryarray([]);
          }
        }
        if (stanza.is("message")) {
          let getReceivestanza = stanza.getChild("archived");
          if (getReceivestanza?.name === "archived") {
            getReceivedmessage(stanza);
          } else {
            let getJid = url[1] === "admin-chat" ? jid : props.jid;
            getChathistory(stanza, getJid);
          }
        }
      });
      xmpp.on("status", (status) => {
        console.debug("Status", status);
      });
      xmpp.start().then(() => {});
    } else {
      if (props.xmppclient.status === "online") {
        xmppObject = props.xmppclient;
        await callUserlist(props.xmppclient);
      }
    }
  };

  const callUserlist = async (xmpp) => {
    let access_token = "";
    if (url[1] === "admin-chat") {
      access_token = url[2];
    } else {
      access_token = props?.access_token;
    }
    let getList = await postRequestcall(MY_CHAT_LIST, access_token, "");
    let userdetail = {};
    let getUserdetailarray = [];
    if (getList?.status === 200) {
      let getres = await getList.json();
      if (getres?.data?.chat_list?.length > 0) {
        getres?.data?.chat_list.forEach((item) => {
          let last_msg = "";
          if (item?.last_msg !== null) {
            let getExt = item?.last_msg.split(".").pop().toLowerCase();
            switch (true) {
              case imageext.includes(getExt):
                last_msg = "Image";
                break;
              case doucmentext.includes(getExt):
                last_msg = "Document";
                break;
              case videoext.includes(getExt):
                last_msg = "Video";
                break;
              default:
                last_msg = item.last_msg;
                break;
            }
          }
          if (item?.user_detail !== null) {
            userdetail = {
              last_msg: last_msg,
              first_name: item?.user_detail?.first_name,
              image: item?.user_detail?.image,
              image_url: item?.user_detail?.image_url,
              jid: item?.user_detail?.jid,
              last_updated_time: item?.last_updated_time,
            };
            getUserdetailarray.push(userdetail);
          }
        });
        const filterUserlist = getUserdetailarray.filter(
          (item) => item.jid === getjidFromurl
        );
        if (access_token !== getjidFromurl) {
          // If jid not present then append to list
          if (filterUserlist.length === 0) {
            if (getjidFromurl.includes("_")) {
              let getName = getjidFromurl.split("_");
              userdetail = {
                last_msg: "",
                first_name: getName[0],
                image: null,
                image_url: "",
                jid: getjidFromurl,
                last_updated_time: new Date(),
              };
              getUserdetailarray.unshift(userdetail);
            }
          }
        }
        userlist.length = 0;
        userlist.push(getUserdetailarray);
        console.log("user list",userlist);
        props.fetchChatuserlist(getUserdetailarray);
        setNochatfound(false);
        if (filterUserlist.length === 0) {
          await showReceiverchathistory(xmpp, getUserdetailarray[0]);
        } else {
          await showReceiverchathistory(xmpp, filterUserlist[0]);
        }
      }
    } else if (getList.status === 400) {
       if(url[1] === "admin-chat") {
           if(typeof url[3] === 'undefined'){
            claerList();
           }else{
            if (getjidFromurl.includes("_")) {
              let getName = getjidFromurl.split("_");
              userdetail = {
                last_msg: "",
                first_name: getName[0],
                image: null,
                image_url: "",
                jid: getjidFromurl,
                last_updated_time: new Date(),
              };
              setNochatfound(false);
              getUserdetailarray.push(userdetail);
              props.fetchChatuserlist(getUserdetailarray);
              await showReceiverchathistory(xmpp, getUserdetailarray[0]);
            }  
         }
      }else{
        if (getjidFromurl !== "no-chat") {
          if (getjidFromurl.includes("_")) {
            let getName = getjidFromurl.split("_");
            userdetail = {
              last_msg: "",
              first_name: getName[0],
              image: null,
              image_url: "",
              jid: getjidFromurl,
              last_updated_time: new Date(),
            };
            setNochatfound(false);
            getUserdetailarray.push(userdetail);
            props.fetchChatuserlist(getUserdetailarray);
            await showReceiverchathistory(xmpp, getUserdetailarray[0]);
          }
        } else {
           claerList();
        }
       }
    }
    headerSeo();
  };

  const claerList = () => {
    props.fetchChatuserlist([]);
    setNochatfound(true);
  }

  const headerSeo = () => {
    props.fetchHeaderContent(t("pages.chat.Vendor Chat Panel"), "", "");
  };

  const showReceiverchathistory = async (xmpp, getObj) => {
    getReceiverinformation(getObj);
    let geturl = READ_MSG_NOTIFICATION + `?jid=${getObj?.jid}`;
    let access_token;
    if (url[1] === "admin-chat") {
      access_token = url[2];
    } else {
      access_token = props?.access_token;
    }
    await postRequestcall(geturl, access_token, "");
    await sendqueryforChathistory(xmpp, getObj?.jid);
  };

  const getReceiverinformation = (getObj) => {
    setReceiver({
      ...receiver,
      recerverJid: getObj?.jid,
      receiverimage:
        typeof getObj?.image_url === "undefined" || getObj?.image_url === ""
          ? profileDefault
          : getObj?.image_url,
      receivername: getObj?.first_name,
    });
  };

  // Getting send query for chat history
  const sendqueryforChathistory = async (xmpp, userJid) => {
    let uid = Date.now();
    let message = xml(
      "iq",
      {
        xmlns: "jabber:client",
        type: "set",
        id: uid,
      },
      xml(
        "query",
        { xmlns: "urn:xmpp:mam:2" },
        xml(
          "x",
          { xmlns: "jabber:x:data", type: "submit" },
          xml(
            "field",
            { var: "FORM_TYPE", type: "hidden" },
            xml("value", {}, "urn:xmpp:mam:2")
          ),
          xml(
            "field",
            { var: "start" },
            xml("value", {}, "2021-08-01T00:00:00Z")
          ),
          xml("field", { var: "with" }, xml("value", {}, userJid))
        ),
        xml(
          "set",
          { xmlns: "http://jabber.org/protocol/rsm" },
          xml("max", {}, 1000),
          xml("before")
        )
      )
    );
    xmpp?.send(message);
  };

  // Get chat history
  const getChathistory = (stanza, jid) => {
    let displaytype = "";
    let getValue = {};
    let extvalue;
    let getMessage = stanza?.getChild("result")?.getChild("forwarded")?.getChild("message")?.getChild("body");
    let getfromJid = getMessage?.parent?.attrs?.from?.split("/");
    getMessage = getMessage?.children[0];
    let getExt = getMessage.split(".").pop().toLowerCase();
    switch (true) {
      case imageext.includes(getExt):
        displaytype = "image";
        break;
      case doucmentext.includes(getExt):
        extvalue = documentImage.filter((item) => item.key === getExt);
        displaytype = "document";
        break;
      case videoext.includes(getExt):
        displaytype = "video";
        break;
      default:
        displaytype = "text";
        break;
    }
    if (getfromJid[0] === jid) {
      getValue = {
        message: getMessage,
        type: "send",
        show: displaytype,
        ext:
          displaytype === "document"
            ? extvalue.length === 0
              ? ""
              : extvalue[0]?.value
            : "",
      };
    } else {
      getValue = {
        message: getMessage,
        type: "receive",
        show: displaytype,
        ext:
          displaytype === "document"
            ? extvalue.length === 0
              ? ""
              : extvalue[0]?.value
            : "",
      };
    }
    historyarray.push(getValue);
  };

  // Receive message

  const getReceivedmessage = (stanza) => {
    let getValue = {};
    let displaytype = "";
    let extvalue;
    let receiverJid = stanza?.attrs?.from?.split("/");
    let getReceivestanza = stanza?.getChild("body");
    getReceivestanza = getReceivestanza?.children[0];
    let getExt = getReceivestanza.split(".").pop().toLowerCase();
    switch (true) {
      case imageext.includes(getExt):
        displaytype = "image";
        break;
      case doucmentext.includes(getExt):
        extvalue = documentImage.filter((item) => item.key === getExt);
        displaytype = "document";
        break;
      case videoext.includes(getExt):
        displaytype = "video";
        break;
      default:
        displaytype = "text";
        break;
    }
    getValue = {
      message: getReceivestanza,
      type: "receive",
      show: displaytype,
      ext:
        displaytype === "document"
          ? extvalue.length === 0
            ? ""
            : extvalue[0]?.value
          : "",
    };
    // Append last msg to user list of current receiver
    let userdetail = {};
    let getUserdetailarray = [];
    console.log("user list",userlist)
    userlist[0]?.forEach((item) => {
      if (item.jid === receiverJid[0]) {
        let last_msg = "";
        let getExt = getReceivestanza.split(".").pop().toLowerCase();
        switch (true) {
          case imageext.includes(getExt):
            last_msg = "Image";
            break;
          case doucmentext.includes(getExt):
            last_msg = "Document";
            break;
          case videoext.includes(getExt):
            last_msg = "Video";
            break;
          default:
            last_msg = getReceivestanza;
            break;
        }
        userdetail = {
          ...item,
          last_msg: last_msg,
        };
        getUserdetailarray.push(userdetail);
      } else {
        getUserdetailarray.push(item);
      }
    });
    console.log("get user detail",getUserdetailarray);
     props.fetchChatuserlist(getUserdetailarray);
    // update the receive msg to chat list
    let getcurrentjid = window.location.pathname.split("/").pop();
    console.log("receive message",getValue, receiverJid, getjidFromurl, getcurrentjid);

    if(receiverJid[0] === getcurrentjid){
      dispatch(setStoreMessage({message:getValue}))
    }
  };

  // get search name
  const searchonChange = (e) => {
    e.preventDefault();
    setSearhname(e.target.value);
  };

  const showReceiverchat = async (getObj, back, xmpp) => {
    let xmppobject = xmpp === "" ? props.xmppclient : xmpp;
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
    localStorage.clear("chatList");
    historyarray.length = 0;
    setHistoryarray([]);
    await showReceiverchathistory(xmppobject, getObj);
    console.log("getObj", getObj)

    setShowchat(true);
    if (back !== true) {
      let getCurrenturl = window.location.pathname.split("/");
      if (getCurrenturl[1] === "chat") {
        navigate(`/chat/${getObj.jid}`);
      } else {
        navigate(`/admin-chat/${getCurrenturl[2]}/${getObj.jid}`);
      }
    }
  };

  const navigateToprevpage = () => {
    let getCurrenturl = window.location.pathname.split("/");
    if (getCurrenturl[1] !== "admin-chat") {
      navigate("/");
    }
  };

  return (
    <div className="layout-wrapper d-lg-flex">
      {/* start chat-leftsidebar  */}
      <div
        className="chat-leftsidebar me-lg-1 ms-lg-0"
        style={{ display: showChat === false ? "block" : "" }}
      >
        <div className="tab-content">
          {/* Start chats tab-pane */}
          <div
            className="tab-pane fade show active"
            id="pills-chat"
            role="tabpanel"
            aria-labelledby="pills-chat-tab"
          >
            {/* Start chats content  */}
            <div>
              <div className="px-4 pt-4 header_list">
                <div className="vendor-panel">
                  <img
                    src={girne_logo}
                    alt="girne"
                    onClick={() => navigateToprevpage()}
                  />
                  <h4>{t("pages.chat.Vendor Chat Panel")}</h4>
                </div>
                {!nochatfound && (
                  <div className="product_search mb-3">
                    <div className="input-group">
                      <input
                        placeholder={t("pages.chat.Search users")}
                        className="form-control"
                        value={searchname}
                        onChange={(e) => searchonChange(e)}
                      />
                      <span className="input-group-text">
                        <label htmlFor="searchform" className="search-icon">
                          <img
                            src={MAGNIFY}
                            alt="search"
                            height="22"
                            width="22"
                          ></img>
                        </label>
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* Start chat-message-list  */}
              <div>
                <div className="chat-message-list px-2" data-simplebar>
                  <ul className="list-unstyled chat-list chat-user-list">
                    {props?.userchatlist
                      .filter((label) => {
                        if (searchname === "") {
                          return label;
                        }
                        if (
                          label.first_name
                            ?.toLowerCase()
                            .includes(searchname?.toLowerCase())
                        ) {
                          return label;
                        }
                        return null;
                      })
                      .map((item, index) => (
                        <li key={index} onClick={() => showReceiverchat(item, false, "")}>
                          <a href>
                            <div className="d-flex">
                              <div className="chat-user-img online align-self-center me-3 ms-0">
                                <img
                                  onError={(event) => {
                                    event.target.src = profileDefault;
                                  }}
                                  src={
                                    item?.image === null ||
                                    typeof item?.image_url === "undefined"
                                      ? profileDefault
                                      : item?.image_url
                                  }
                                  className="rounded-circle avatar-xs"
                                  alt="user profile"
                                />
                                <span className="user-status" hidden></span>
                              </div>

                              <div className="flex-grow-1 overflow-hidden">
                                <h5 className="text-truncate font-size-15 mb-1">
                                  {item.first_name}
                                </h5>
                                <p className="chat-user-message text-truncate mb-0">
                                  {item.last_msg}
                                </p>
                              </div>
                              <div className="time" hidden>
                                05 min
                              </div>
                            </div>
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              {/* End chat-message-list */}
            </div>
            {/* Start chats content */}
          </div>
          {/* End chats tab-pane */}
        </div>
      </div>
      {/* end chat-leftsidebar  */}
      {/* Start User chat */}
      <ChatPage
        receiver={receiver}
        showChat={showChat}
        senderImage={senderImage}
        nochatfound={nochatfound}
        setShowchat={setShowchat}
      />
      {/* End User chat */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  jid: state?.login?.jid,
  jpass: state?.login?.jpass,
  userchatlist: state?.languageState?.userchatlist,
  xmppclient: state?.languageState?.xmppclient,
  msg: state?.languageState?.msg,
});

export default connect(mapStateToProps, {
  fetchChatuserlist,
  storeConnection,
  storeChathistory,
  storeChat,
  fetchHeaderContent,
})(UserlistPage);
